const errorsDictionary = {
  "request-benefit-not-found": "this-request-has-not-been-found",
  "punctual-contribution-amount-below-minimum-error":
    "contribution-below-the-minimum-allowed-limit",
  "benefit-request-not-approvable":
    "this-request-has-already-been-rejected-and-cannot-be-approved",
  "benefit-request-not-deniable":
    "this-request-has-already-been-approved-and-cannot-be-rejected",
};

const getErrorMessage = ({ code }) => {
  if (!errorsDictionary[code]) {
    return code;
  }

  return errorsDictionary[code];
};

export default getErrorMessage;
